<template>
  <div class="tag-item" v-if="rowModel[configModel.model]">
    {{ tableText }}
  </div>
</template>

<script>
  export default {
    name: 'DesignTableColumn',
    data() {
      return {
        searchModel: {},
        dValule: "",
      }

    },
    watch: {
      dValule: function() {
        this.$emit("input", this.dValule)
      },
      configModel: {
        deep: true,
        handler: function() {
        }
      }
    },
    computed: {
      tableText: function() {
        let that = this
        // 获得原本直接返回的文本
        let orgText = that.rowModel[that.configModel.model]
        // 文本无需改变模式,直接返回对应的文本
        if (!that.configModel.textChange || !orgText) {
          return orgText
        }

        let optionsModel = that.configModel.options
        // 获得文本属性字段
        let labelKey = optionsModel.dynamic == 0 ? 'label' : optionsModel.remoteLabel
        // 获得值属性字段
        let valueKey = optionsModel.dynamic == 0 ? 'value' : optionsModel.remoteValue

        let filterText = ''
        // 判断当前文本转化是单选还是多选
        // 1.1 checkbox结果也是数字隔断
        if (optionsModel.hasOwnProperty("optionsList") && (optionsModel.multiple || that.configModel.type=="checkbox")) {
          // 多选模式,按逗号分隔文本
          let orgList = orgText.split(",")
          let filterTextList = []
          optionsModel.optionsList.forEach(function(item) {
            if (orgList.indexOf(item[valueKey]) != -1) {
              filterTextList.push(item[labelKey])
            }
          })
          // console.log(filterTextList);
          return filterTextList.toString()
        } else {
          // 单选模式
          filterText = that.$utils.filterOne(optionsModel.optionsList, valueKey, orgText, labelKey)
          return filterText
        }


      }
    },
    props: {
      // 当前列的配置对象
      configModel: {
        type: Object,
        default: () => {}
      },
      // table当前行对象
      rowModel: {
        type: Object,
        default: () => {}
      },
    },
    components: {

    },
    methods: {

    },
    mounted() {

    }
  }
</script>
<style scoped>
  .search-design-item {
    float: left;
  }
</style>
